import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { environment } from '../environments/environment'
import { RecaptchaModule, RecaptchaFormsModule, RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { TooltipModule } from 'primeng/tooltip';
import { CheckboxModule } from 'primeng/checkbox';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { DropdownModule } from 'primeng/dropdown';




import { AppComponent } from './app.component';
import { ContainerComponent } from './components/container/container.component';
import { TitleComponent } from './components/title/title.component';
import { OnlynumberDirective } from './shared/directives/numbers-only.directive';
import { HeaderComponent } from './components/header/header.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { SupportComponent } from './components/support/support.component';
import { TooltipHelpComponent } from './components/tooltip-help/tooltip-help.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { QuestionsAndAnswersComponent } from './components/questions-and-answers/questions-and-answers.component';
import { ArticlesComponent } from './components/articles/articles.component';
import { FooterComponent } from './components/footer/footer.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import {AccordionModule} from 'primeng/accordion';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { InMemoryService, InMemoryServiceConfig } from './shared/in-memory-web-api/in-memory.service';
import { APP_INITIALIZER } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SiteStettingService } from './core/services/site-stetting.service';
import { LoginCombinedEduGovComponent } from './page/login-combined-edu-gov/login-combined-edu-gov.component';
import { LoginComponent } from './page/login/login.component';
import { ButtonImageComponent } from './components/button-image/button-image.component';
import { LoginViaPasswordComponent } from './components/login-via-password/login-via-password.component';
import { LoaderComponent } from './components/loader/loader.component';
import { LoginViaSMSComponent } from './components/login-via-sms/login-via-sms.component';
import { LoginViaOtpComponent } from './components/login-via-otp/login-via-otp.component';
import { TogglePasswordDirective } from './shared/directives/toggle-password.directive';
import { AppConfigService } from './core/services/app-config.service';
import { AppMessagesService } from './core/services/app-messages.service';
import { HebrewCharactersDirective, TrackCapsDirective } from './shared/directives/hebrew-characters-capslock.directive';
import { BrowserSupportMessageComponent } from './components/browser-support-message/browser-support-message.component';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { CallsInMemoryService } from './shared/in-memory-web-api/calls-in-memory.service';
import { LoginViaPasswordMoeComponent } from './components/login-via-password-moe/login-via-password-moe.component';
import { LoginViaOtpMoeComponent } from './components/login-via-otp-moe/login-via-otp-moe.component';
import { LettersAndNumbersOnlyDirective } from './shared/directives/letters-and-numbers-only.directive';
import { GeneralErrorComponent } from './components/general-error/general-error.component';
import { UserLockedComponent } from './components/user-locked/user-locked.component';
import { LogoutMessageComponent } from './components/logout-message/logout-message.component';
// import { LoginOtpOnlyComponent } from './components/login-otp-only/login-otp-only.component';




var importsModules: Array<any> = [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    InputTextModule,
    CalendarModule,
    TooltipModule,
    CheckboxModule,
    MessagesModule,
    MessageModule,
    DropdownModule,
    CarouselModule,
    AccordionModule,
    HttpClientModule,
    ProgressSpinnerModule,


    
   
];

if (environment.inMemoryWebApi) {
  //push 'HttpClientInMemoryWebApiModule' to bypass web api calls
  console.log('Activate "InMemoryWebApiModule" !');
  importsModules.push(HttpClientInMemoryWebApiModule.forRoot(InMemoryService, InMemoryServiceConfig));
}


@NgModule({
  declarations: [
    AppComponent,
    ContainerComponent,
    TitleComponent,
    OnlynumberDirective,
    HeaderComponent,
    SideMenuComponent,
    SupportComponent,
    TooltipHelpComponent,
    NavbarComponent,
    FooterComponent,
    QuestionsAndAnswersComponent,
    ArticlesComponent,
    LoginCombinedEduGovComponent,
    LoginComponent,
    ContainerComponent,
    ButtonImageComponent,
    LoginViaPasswordComponent,
    LoginViaSMSComponent, 
    //ClosePopupDirective,
    TogglePasswordDirective,
    LoaderComponent,
     LoginViaOtpComponent,
     TrackCapsDirective,
     HebrewCharactersDirective,
     BrowserSupportMessageComponent,
     ErrorMessageComponent,
     LoginViaOtpMoeComponent,
     LoginViaPasswordMoeComponent,
     LettersAndNumbersOnlyDirective,
     GeneralErrorComponent,
     UserLockedComponent,
     LogoutMessageComponent,
    //  LoginOtpOnlyComponent,
    ],
  imports: importsModules , 
  providers: [
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AppConfigService],
      useFactory: (appConfigService: AppConfigService) => {
        return () => {
          return appConfigService.loadAppConfig();
        };
      }
    },
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: "iw"
    },SiteStettingService , AppMessagesService ,CallsInMemoryService 
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
//export function getBaseUrl() {
//  return environment.baseUrl2ApiCalls;
//}

